"use client";

import dynamic from "next/dynamic";
import { Tabs as AntdTabsType } from "antd-mobile";

/**
 * antd-mobile client-only exports
 * 统一在这里控制 ssr: false
 */

export const Popup = dynamic(() => import("antd-mobile").then((m) => m.Popup), { ssr: false });

export const TabsTab = dynamic(() => import("antd-mobile").then((m) => m.Tabs.Tab), {
  ssr: false,
}) as typeof AntdTabsType.Tab;

// dynamic() 返回的是包装组件，不是 loader 里 return 的那个。原先在 loader 内部给
// mod.Tabs 挂 .Tab，挂不到导出的包装组件上，<Tabs.Tab> 一直取到 undefined。
// 改为挂在导出对象上，<Tabs.Tab> 与 <TabsTab> 两种写法都指向同一个 Tab。
const TabsBase = dynamic(() => import("antd-mobile").then((m) => m.Tabs), { ssr: false });

export const Tabs = Object.assign(TabsBase, { Tab: TabsTab }) as unknown as typeof AntdTabsType;

export const Toast = {
  show: (...args: Parameters<typeof import("antd-mobile")["Toast"]["show"]>) =>
    import("antd-mobile").then((m) => m.Toast.show(...args)),
  clear: () => import("antd-mobile").then((m) => m.Toast.clear()),
};
